<template>
  <div>
    <b-card v-if="isFiltered()">
      <project-stats :project="project"></project-stats>
    </b-card>
    <project-list-item v-for="(child, index) in project.children" :key=" index + '_' + child.id" :project="child" :level="level+1"></project-list-item>
  </div>
</template>

<script>
  import ProjectStats from './ProjectStats'
  export default {
    name: 'ProjectListItem',
    components: {ProjectStats},
    props: {
      project: {
        default: null
      },
      level: {
        default: 0
      }
    },
    computed: {
      projectQ: {
        get () {
          return this.$store.getters['project/projectQ']
        },
        set (val) {
          this.$store.commit('project/projectQ', val)
        }
      }
    },
    methods: {
      isFiltered () {
        if (!this.project.workpack) {
          return false
        }
        if (this.projectQ) {
          return  this.project.name.toLowerCase().indexOf(this.projectQ.toLowerCase()) > -1
        }

        return true
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectListItem.vue